// extracted by mini-css-extract-plugin
export var bottomWave = "bp_cV";
export var button = "bp_cf";
export var buttonContainer = "bp_N";
export var buttonFooter = "bp_fL";
export var container = "bp_b";
export var middleWave = "bp_cT";
export var section = "bp_d";
export var subtitle = "bp_cj";
export var textContainer = "bp_cW";
export var title = "bp_h";